import React from "react";
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import organizationService from "../../services/organizationService"
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import PageTitle from "../common/PageTitle";
import { confirm } from '../common/modals/confirmService';
import Confirmation from '../common/modals/confirmation';
import OrganizationStats from './modals/organizationStats'
import QrCode from "../common/modals/qrcode";
import { round } from '../../utils/utils'

export default class Organizations extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			organizations: [],
			unfinishedOrganizations: [],
			showConfirmationModal: false,
			showOrganizationStatsModal: false,
			showQRCodeModal: false,
		}
		this.options = {
			autoClose: 3000,
			hideProgressBar: true,
		};
		this.handleSubmitOrganization = this.handleSubmitOrganization.bind(this);
		this.renderPlanComponent = this.renderPlanComponent.bind(this);
		this.handleRemoveOrganization = this.handleRemoveOrganization.bind(this);
		this.returnUnifinishedOrganizations = this.returnUnifinishedOrganizations.bind(this);
		this.handleClose = this.handleClose.bind(this)
		this.openQrCodeModal = this.openQrCodeModal.bind(this)
		this.closeQrCodeModal = this.closeQrCodeModal.bind(this)
	}

	componentDidMount() {
		this.loadOrganizations();
	}

	loadOrganizations() {
		organizationService.getByProfileUsername().then(result => {
			if (result.organizations.length > 0) {
				const unfinishedOrganizations = []
				result.organizations.forEach(organization => {
					if (organization.subscription && !organization.device) {
						unfinishedOrganizations.push(organization)
					}
				})
				this.setState({
					organizations: result.organizations,
					unfinishedOrganizations,
					showConfirmationModal: unfinishedOrganizations.length > 0
				})
			} else {
				this.setState({
					organizations: [],
				})
			}
		}).catch(error => {
			toast.error(error.response, this.options)
		});
	}

	handleSubmitOrganization(organization) {
		organizationService.add(organization)
			.then(response => {
				toast.success("Organization is successfully created!", this.options);
				this.loadOrganizations()
			}).catch(error => {
				toast.error(error.response, this.options)
			});
	}

	renderPlanComponent(organization) {
		this.setState({
			organization: organization,
			activeClass: organization._id
		})
	}

	handleRemoveOrganization(organizationId) {
		confirm('Are you sure you want to remove organization?', { title: 'Confirm action' }).then(() => {
			organizationService.remove(organizationId).then(response => {
				toast.success("Organization is successfully deleted!", this.options);
				this.loadOrganizations()
			}).catch(error => {
				toast.error(error.response, this.options)
			})
		}, () => {
		});
	}

	showOrganizationStats(organization) {
		this.setState({ showOrganizationStatsModal: true, statsOrganization: organization })
	}

	handleClose() {
		this.setState({
			showConfirmationModal: false,
			showOrganizationStatsModal: false,
			statsOrganization: null
		});
	}

	openQrCodeModal(id) {
		this.setState({
			showQRCodeModal: true,
			organizationId: id
		})
	}

	closeQrCodeModal() {
		this.setState({
			showQRCodeModal: false,
			organizationId: null
		})
	}

	returnUnifinishedOrganizations() {
		const { unfinishedOrganizations } = this.state
		return (
			<div>
				<Row noGutters className="page-header py-4">
					<PageTitle title="You have unfinished organization setup" subtitle="finish organization setup" className="text-sm-left" />
				</Row>
				<Card className="mb-4 card-custom">
					<CardHeader className="border-bottom card-header-custom">
						<h6 className="m-0">
							Please setup caller Id for this organizations
						</h6>
					</CardHeader>
					<CardBody className="p-0 pb-3 table-responsive">
						<table className="table  mb-0">
							<thead className="lightblue-bg">
								<tr>
									<th className="border-0">Unfinished organization names</th>
								</tr>
							</thead>
							<tbody>
								{unfinishedOrganizations.map((organization, i) =>
									(<tr key={'unfinished-organization-' + i}>
										<td><NavLink to={`/dashboard/payment/${organization._id}`}>{organization.name}</NavLink></td>
									</tr>
									))}
							</tbody>
						</table>
					</CardBody>
				</Card>
			</div>
		)
	}


	render() {
		const { organizations, showConfirmationModal, showOrganizationStatsModal, statsOrganization, showQRCodeModal, organizationId } = this.state;

		return (
			<div className="wrapper organization-page-container">
				{showQRCodeModal && organizationId ? <QrCode show={showQRCodeModal} code={organizationId} handleClose={this.closeQrCodeModal} /> :  null}
				{showOrganizationStatsModal ? <OrganizationStats show={showOrganizationStatsModal} handleClose={this.handleClose} organization={statsOrganization} /> : null}
				{showConfirmationModal ?
					<Confirmation show={showConfirmationModal} proceed={this.handleClose} showNoOption={false} okLabbel="OK" handleClose={this.handleClose} confirmation={this.returnUnifinishedOrganizations()} />
					: null}
				<Row noGutters className="page-header py-4">
					<Col xs="6">
						<PageTitle title="Organization" subtitle="Manage Organizations and Offices" className="text-sm-left text-white" />
					</Col>
					<Col xs="6" className="text-right">
						{/* <p> <NavLink to={`/dashboard/organization/add`}><button type="submit" className="btn btn-lightblue" >  <i className="material-icons">add</i> Add new organization</button></NavLink></p> */}
					</Col>
				</Row>

				{organizations.length > 0 ?
					<Row>
						{
							organizations.map((organization, i) =>
								<Col key={organization._id} xs="6">
									<Card className="mb-4 card-custom" >
										<CardHeader className="border-bottom card-header-custom">
											<h4 className="text-white">{organization.name} <span className="icon pull-right" aria-hidden="true" onClick={this.handleRemoveOrganization.bind(this, organization._id)}>
												<svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="20" viewBox="0 0 17.5 20">
													<path id="Path_269" data-name="Path 269" d="M10.469-1.25h.938a.469.469,0,0,0,.469-.469v-8.437a.469.469,0,0,0-.469-.469h-.937a.469.469,0,0,0-.469.469v8.438A.469.469,0,0,0,10.469-1.25Zm6.406-13.125H13.656L12.328-16.59a2.079,2.079,0,0,0-1.608-.91H6.781a2.079,2.079,0,0,0-1.608.91L3.844-14.375H.625A.625.625,0,0,0,0-13.75v.625a.625.625,0,0,0,.625.625H1.25V.625A1.876,1.876,0,0,0,3.125,2.5h11.25A1.876,1.876,0,0,0,16.25.625V-12.5h.625a.625.625,0,0,0,.625-.625v-.625A.625.625,0,0,0,16.875-14.375ZM6.712-15.511a.26.26,0,0,1,.2-.114h3.673a.26.26,0,0,1,.2.114l.682,1.136H6.031ZM14.375.625H3.125V-12.5h11.25ZM6.094-1.25h.938A.469.469,0,0,0,7.5-1.719v-8.437a.469.469,0,0,0-.469-.469H6.094a.469.469,0,0,0-.469.469v8.438A.469.469,0,0,0,6.094-1.25Z" transform="translate(0 17.5)" fill="#6c7486" />
												</svg>
											</span> </h4>
										</CardHeader>

										<CardBody className="p-10 pb-3 card-body-custom">
											<div className="card-body-list">
												<div className="card-list-items border-bottom">
													<div className="card-list-item">
														<h6>Plan</h6>
														<p>{organization.subscription ? organization.subscription.planId : 'N/A'}</p>
													</div>
													<div className="card-list-item">
														<h6> Automatic billing </h6>
														<p>{organization.subscription ? organization.subscription.neverExpires ? 'ON' : 'OFF' : 'N/A'}</p>
													</div>
													<div className="card-list-item">
														<h6> Expiration date</h6>{organization.subscription ? !organization.subscription.neverExpires ? new Date(organization.subscription.billingPeriodEndDate).toDateString() : 'N/A' : 'N/A'}
														<p></p>
													</div>
												</div>
												<div className="card-list-items border-bottom">
													<div className="card-list-item">
														<h6> VoIP number </h6>
														<p>{organization.device ? organization.device && organization.device.number ? organization.device.number.number : 'N/A' : 'N/A'}</p>
													</div>
													<div className="card-list-item">
														<h6> Available minutes </h6>
														<p>{organization.limit ? round(organization.limit !== 0 ? organization.limit / 60 : organization.limit, 0) : 'N/A'}</p>
													</div>
													<div className="card-list-item">
														<h6> Additional minutes </h6>
														<p>{organization.extraLimit ? round(organization.extraLimit !== 0 ? organization.extraLimit / 60 : organization.extraLimit, 0) : 'N/A'}</p>
													</div>
												</div>
												<div className="button-organization">

													{organization.subscription ?
														<div className="card-list-btns">
															{organization._id ? <button type="submit" className="btn btn-outline-lightblue" onClick={() => this.openQrCodeModal(organization._id)}>Get QRCode</button> : null}
															{/* <NavLink to={`/dashboard/organization/${organization._id}`}>	<button type="submit" className="btn btn-outline-lightblue" >Change GCP plan </button></NavLink> */}
															{/* {organization.device ? <NavLink to={`/dashboard/extensions/${organization._id}`}>	<button type="submit" className="btn btn-outline-lightblue">Extension list </button></NavLink> : null} */}
															{/* {organization.device ? <NavLink to={`/dashboard/transfers/${organization._id}`}>	<button type="submit" className="btn btn-outline-lightblue">Organization transfer </button></NavLink> : null} */}
															{/* {organization.device ? <NavLink to={`/dashboard/payment/${organization._id}`}>	<button type="submit" className="btn btn-outline-lightblue">Set Caller ID </button></NavLink> : null} */}
															{/* <button type="submit" className="btn btn-outline-lightblue" onClick={this.showOrganizationStats.bind(this, organization)}>Organization Statistic</button> */}
														</div> :
														<div className="card-list-btns">
															{organization._id ? <button type="submit" className="btn btn-outline-lightblue" onClick={() => this.openQrCodeModal(organization._id)}>Get QRCode</button> : null}
															{/* {organization.device ? <NavLink to={`/dashboard/transfers/${organization._id}`}>	<button type="submit" className="btn btn-outline-lightblue">Organization transfer </button></NavLink> : null} */}
															{/* <NavLink to={`/dashboard/organization/${organization._id}`}><button type="submit" className="btn btn-outline-lightblue" >Buy GCP plan </button></NavLink> */}
															{/* <button type="submit" className="btn btn-outline-lightblue" onClick={this.showOrganizationStats.bind(this, organization)}>Organization Statistic</button> */}
														</div>}
												</div>
											</div>
										</CardBody >
									</Card>
								</Col>)
						}
					</Row> : <div className='alert alert-info'>You don't have any organizations!</div>}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/organizationComponent/organizations.js